import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { AcceptedQueryTypes } from '@commercetools/frontend-sdk/lib/types/Query';
import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';
import {
  DownloadOrderPdfActionReturn,
  GetOrderDetailActionReturn,
  GetOrderDetailQuery,
  GetOrdersPageActionReturn,
  GetOrdersPageQuery,
  OrderActions,
} from '../../types/actions/OrderActions';

export type { OrderActions };

export const getOrderActions = (sdk: SDK<ComposableCommerceEventsB2B>): OrderActions => ({
  getOrdersPage: async (
    query?: GetOrdersPageQuery,
    options: {
      parallel?: boolean;
      customHeaderValue?: string;
      serverOptions?: ServerOptions;
    } = {},
  ) => {
    const response = await sdk.callAction<GetOrdersPageActionReturn>({
      actionName: 'orders/getOrdersPage',
      query: query as AcceptedQueryTypes | undefined,
      parallel: options.parallel,
      customHeaderValue: options.customHeaderValue,
      serverOptions: options.serverOptions,
    });
    return response;
  },
  downloadOrderPdf: async (orderReference: string, options: { serverOptions?: ServerOptions } = {}) => {
    const response = await sdk.callAction<DownloadOrderPdfActionReturn>({
      actionName: 'orders/downloadOrderPdf',
      query: { orderReference } as AcceptedQueryTypes,
      serverOptions: options.serverOptions,
    });
    return response;
  },
  getOrderDetail: async (
    query: GetOrderDetailQuery,
    options: {
      parallel?: boolean;
      customHeaderValue?: string;
      serverOptions?: ServerOptions;
    } = {},
  ) => {
    const response = await sdk.callAction<GetOrderDetailActionReturn>({
      actionName: 'orders/getOrderDetail',
      query: query as unknown as AcceptedQueryTypes | undefined,
      parallel: options.parallel,
      customHeaderValue: options.customHeaderValue,
      serverOptions: options.serverOptions,
    });
    return response;
  },
});
